import React, { useEffect } from "react";
import {
    Button,
    Dropdown,
    Flex,
    Image,
    InfoIcon,
    Input,
    InputLabel,
    Loader,
    RadioGroup,
    RadioGroupItem,
    Text,
    TextArea,
} from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import {
    Container,
    ContainerFluid,
    ErrorMessage,
    LabelRequired,
} from "../../../common/styles";
import {
    I18N_NS_EXPENSE,
    QUERY_KEY,
    TYPE_ENERGY,
    TYPE_VEHICULE,
    VALIDATORS_ADD_EXPENSE_KM_FR,
} from "../constants";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
    _api_add_expense_km_ch,
    _api_add_expense_km_fr,
    _api_get_bareme,
    _api_get_expense,
    _api_update_expense_km_fr,
} from "../api";
import { ROUTES } from "../../../constants/routes";
import { TextCategory } from "./ExpensesAddFormClassic";
import { useState } from "react";
import CommentSection from "./CommentSection/CommentSection";
import moment from "moment";
import { useWhereIamExpenses } from "../store/useWhereIam.store";
import CategoryExpense from "./CategoryExpense/CategoryExpense";
import { useToastGlobal } from "../../../stores/useToastGlobal";

const ExpensesUpdateFormKmFr = () => {
    const { t } = useTranslation(I18N_NS_EXPENSE);
    const navigate = useNavigate();
    const globalToast = useToastGlobal();

    const [dropdownPower, setDropdownPower] = useState(null);

    const {
        id_category: param_id_category,
        id_expense: param_id_expense,
        type_form: param_type_form,
        id_report: param_id_report,
    } = useParams();

    const path_detail = ROUTES.expenses.detail;

    const whereIam = useWhereIamExpenses();

    const _goback = () => {
        return navigate(-1);
    };

    const {
        handleSubmit,
        register,
        formState: { errors },
        control,
        setValue,
        watch,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            title: "",
            power: null,
        },
    });

    const {
        data: expense,
        isLoading: isLoadingExpense,
        isFetching: isFetchingExpense,
    } = useQuery(
        [QUERY_KEY + "::expense", param_id_expense],
        () =>
            _api_get_expense({
                id_expense: param_id_expense,
                id_expense_report: param_id_report,
            }),
        {
            refetchOnWindowFocus: false,
            refetchOnMount: true,
            onSuccess: (data) => {
                // if (!data?.success) {
                //     return navigate(ROUTES.expenses.home);
                // }
                const { custom_fields } = data?.expense;
                const default_type_vehicle = TYPE_VEHICULE.find(
                    (el) => el.value === custom_fields["vehicle-type"]
                );
                setValue("type_vehicule", default_type_vehicle);
                setValue(
                    "energy",
                    TYPE_ENERGY.find(
                        (el) => el.value === custom_fields["vehicle-power-type"]
                    )
                );
                const default_power =
                    default_type_vehicle?.dropdown_power?.values.find(
                        (el) =>
                            parseInt(el?.value) ===
                            parseInt(custom_fields["power-value"])
                    );

                const json_power = {
                    id: default_power?.value,
                    value: default_power?.value,
                    header: default_power?.header,
                };
                setValue("power", json_power);
                setDropdownPower(json_power);
            },
        }
    );

    const { mutate, isLoading: isMutating } = useMutation((data) => {
        const {
            arrival,
            comment,
            date,
            departure,
            distance,
            title,
            power,
            energy,
            type_vehicule,
        } = data;
        return _api_update_expense_km_fr({
            param_id_expense: param_id_expense,
            name: title,
            expense_category_id: parseInt(param_id_category),
            expense_date: date,
            comment: comment,
            rate: 1,
            custom_fields: [
                {
                    code: "departure-place",
                    value: departure,
                },
                {
                    code: "arrival-place",
                    value: arrival,
                },
                {
                    code: "distance",
                    value: parseFloat(distance),
                },
                {
                    code: "vehicle-power-type",
                    value: energy?.value,
                },
                {
                    code: "vehicle-type",
                    value: type_vehicule?.value,
                },
                {
                    code: "power-value",
                    value: parseInt(power?.value),
                },
            ],
        });
    });

    /**
     * submit add expense
     */
    const onSubmit = (data) => {
        mutate(data, {
            onSuccess: (data) => {
                if (data?.success) {
                    const path_detail_params = path_detail.custom_route(
                        path_detail.route,
                        param_id_report
                    );
                    globalToast.setShow({
                        visible: true,
                        content: "Dépense modifiée et enregistrée",
                        level: "success",
                    });
                    _goback();
                } else {
                    globalToast.setShow({
                        visible: true,
                        content:
                            data?.message ??
                            "Une erreur est survenue lors de la modification de la dépense",
                        level: "danger",
                    });
                }
            },
        });
        return;
    };

    const _watch = watch();
    // BAREM FETCH
    const { data, isLoading, isFetching, refetch } = useQuery(
        [
            "timeline::getBarem",
            {
                power_type: _watch?.energy?.value,
                vehicle_type: _watch?.type_vehicule?.value,
                power_value: _watch?.power?.value ?? "",
            },
        ],
        () =>
            _api_get_bareme({
                power_type: _watch?.energy?.value,
                vehicle_type: _watch?.type_vehicule?.value,
                distance: _watch?.distance,
                power_value: _watch?.power?.value ?? "",
            }),
        {
            refetchOnWindowFocus: false,
        }
    );

    if (isLoadingExpense || isFetchingExpense) return <Loader />;

    const power_value = expense?.expense?.custom_fields["power-value"];
    const type_vehicule = expense?.expense?.custom_fields["vehicle-type"];
    const selected_type_vehicle_values = TYPE_VEHICULE.find(
        (el) => el.value === type_vehicule
    )?.dropdown_power?.values;
    const default_power_value = selected_type_vehicle_values?.find(
        (el) => el?.value === parseInt(power_value)
    );

    const isOnManagerPage = whereIam.isManagerPage;

    return (
        <ContainerFluid>
            <Container gap="gap.large" style={{ marginTop: "24px" }}>
                <Wrapper fill column gap="gap.medium">
                    <Flex
                        style={{
                            paddingInline: "8px",
                        }}
                        fill
                        space="between"
                    >
                        <Flex styles={{}} column gap="gap.large">
                            <TitlePage>
                                {t("forms.km_fr.title_update")}
                            </TitlePage>
                            {/* show/update category */}
                            <CategoryExpense
                                state={{
                                    category: {
                                        icon: expense?.expense?.category
                                            ?.icon_url,
                                        name: expense?.expense?.category?.name,
                                    },
                                }}
                            />
                        </Flex>
                        <Text
                            styles={{
                                cursor: "pointer",
                                color: "#5b5fc7",
                                fontWeight: 600,
                            }}
                            primary
                            content={t("common.cancel")}
                            onClick={_goback}
                        />
                    </Flex>
                    <WhiteBoard fill column gap="gap.large">
                        <Flex
                            column
                            gap="gap.large"
                            as="form"
                            onSubmit={handleSubmit(onSubmit)}
                        >
                            <Flex>
                                <CardTitle
                                    content={t("forms.km_fr.card_title")}
                                />
                            </Flex>
                            <Flex column gap="gap.medium">
                                <Flex gap="gap.large">
                                    <Flex column>
                                        <Input
                                            label={
                                                <>
                                                    {t(
                                                        "forms.km_fr.date.label"
                                                    )}
                                                    <LabelRequired
                                                        content={"*"}
                                                    />
                                                </>
                                            }
                                            type="date"
                                            {...register(
                                                "date",
                                                VALIDATORS_ADD_EXPENSE_KM_FR.date
                                            )}
                                            defaultValue={expense?.expense.date}
                                            error={!!errors?.date?.message}
                                            fluid
                                            styles={{
                                                width: "212px",
                                            }}
                                        />
                                        <ErrorMessage
                                            content={t(errors?.date?.message)}
                                        />
                                    </Flex>
                                </Flex>

                                <Flex fill gap="gap.medium">
                                    <Flex column fill>
                                        <Input
                                            label={t(
                                                "forms.km_fr.departure.label"
                                            )}
                                            {...register("departure")}
                                            defaultValue={
                                                expense?.expense.custom_fields[
                                                    "departure-place"
                                                ]
                                            }
                                            clearable
                                            fluid
                                            error={!!errors?.departure?.message}
                                        />
                                        <ErrorMessage
                                            content={t(
                                                errors?.departure?.message
                                            )}
                                        />
                                    </Flex>
                                    <Flex column fill>
                                        <Input
                                            label={t(
                                                "forms.km_fr.arrival.label"
                                            )}
                                            {...register("arrival")}
                                            defaultValue={
                                                expense?.expense.custom_fields[
                                                    "arrival-place"
                                                ]
                                            }
                                            clearable
                                            fluid
                                            error={!!errors?.arrival?.message}
                                        />
                                        <ErrorMessage
                                            content={t(
                                                errors?.arrival?.message
                                            )}
                                        />
                                    </Flex>
                                </Flex>
                                <Flex vAlign="end" column>
                                    <Flex vAlign="end">
                                        <Input
                                            label={
                                                <>
                                                    {t(
                                                        "forms.km_fr.distance.label"
                                                    )}
                                                    <LabelRequired
                                                        content={"*"}
                                                    />
                                                </>
                                            }
                                            type="number"
                                            {...register(
                                                "distance",
                                                VALIDATORS_ADD_EXPENSE_KM_FR.distance
                                            )}
                                            defaultValue={
                                                expense?.expense.custom_fields
                                                    .distance
                                            }
                                            error={!!errors?.distance?.message}
                                            clearable
                                            errorIndicator={false}
                                            fluid
                                            styles={{
                                                borderRadius:
                                                    "4px 0px 0px 4px!important",
                                                width: "212px",
                                            }}
                                            onBlur={() => refetch()}
                                        />
                                        <Button
                                            disabled
                                            content={
                                                <Text
                                                    styles={{
                                                        color: "#242424",
                                                    }}
                                                    content={"Km"}
                                                />
                                            }
                                            flat
                                            fluid
                                            styles={{
                                                borderRadius: "0px 4px 4px 0px",
                                                width: "fit-content!important",
                                                backgroundColor: "#C7C7C7",
                                                padding: 0,
                                                minWidth: "36px",
                                                // width: "40px";
                                            }}
                                        />
                                    </Flex>
                                    <Flex>
                                        <ErrorMessage
                                            content={t(
                                                errors?.distance?.message
                                            )}
                                        />
                                    </Flex>
                                </Flex>
                                <Flex>
                                    <Flex column>
                                        <InputLabel
                                            content={
                                                <>
                                                    {t(
                                                        "forms.km_fr.vehicule.type"
                                                    )}
                                                    <LabelRequired
                                                        content={"*"}
                                                    />
                                                </>
                                            }
                                        />
                                        <Flex>
                                            <RadioGroup
                                                styles={{
                                                    flexWrap: "wrap",
                                                }}
                                                {...register("type_vehicule")}
                                                items={TYPE_VEHICULE.map(
                                                    (el) => {
                                                        return {
                                                            id: el?.value,
                                                            value: el?.value,
                                                            label: t(el?.label),
                                                            temp: el,
                                                        };
                                                    }
                                                )}
                                                onCheckedValueChange={(
                                                    e,
                                                    i
                                                ) => {
                                                    setValue("power", null);
                                                    setDropdownPower(null);
                                                    setValue(
                                                        "type_vehicule",
                                                        i?.temp
                                                    );
                                                    return;
                                                }}
                                                defaultCheckedValue={
                                                    expense?.expense
                                                        .custom_fields[
                                                        "vehicle-type"
                                                    ]
                                                }
                                            />
                                        </Flex>
                                    </Flex>
                                </Flex>
                                <Flex>
                                    <Flex column>
                                        <InputLabel
                                            content={
                                                <>
                                                    {t(
                                                        "forms.km_fr.energy.type"
                                                    )}
                                                    <LabelRequired
                                                        content={"*"}
                                                    />
                                                </>
                                            }
                                        />
                                        <RadioGroup
                                            items={TYPE_ENERGY?.map((el) => {
                                                return {
                                                    id: el?.value,
                                                    value: el?.value,
                                                    label: t(el?.label),
                                                    temp: el,
                                                };
                                            })}
                                            onCheckedValueChange={(e, i) => {
                                                setValue("energy", i?.temp);
                                                return;
                                            }}
                                            defaultCheckedValue={
                                                expense?.expense.custom_fields[
                                                    "vehicle-power-type"
                                                ]
                                            }
                                        />
                                    </Flex>
                                </Flex>
                                <Flex fill column gap="gap.medium">
                                    {_watch?.type_vehicule?.dropdown_power
                                        ?.show && (
                                        <Flex column>
                                            <InputLabel
                                                content={
                                                    <>
                                                        {t(
                                                            "forms.km_fr.power.label"
                                                        )}
                                                        <LabelRequired
                                                            content={"*"}
                                                        />
                                                    </>
                                                }
                                            />
                                            <Flex as="div" column>
                                                <Controller
                                                    control={control}
                                                    name="power"
                                                    rules={
                                                        VALIDATORS_ADD_EXPENSE_KM_FR.power
                                                    }
                                                    defaultValue={dropdownPower}
                                                    render={({
                                                        field: {
                                                            onChange,
                                                            value,
                                                            onBlur,
                                                            ref,
                                                            name,
                                                        },
                                                    }) => (
                                                        <Dropdown
                                                            fluid
                                                            styles={{
                                                                width: "100%",
                                                            }}
                                                            items={_watch?.type_vehicule?.dropdown_power?.values.map(
                                                                (el) => {
                                                                    return {
                                                                        ...el,
                                                                        selected:
                                                                            el?.value ===
                                                                            parseInt(
                                                                                dropdownPower?.value
                                                                            ),
                                                                    };
                                                                }
                                                            )}
                                                            defaultValue={
                                                                dropdownPower
                                                            }
                                                            checkable
                                                            loadingMessage={
                                                                "chargement"
                                                            }
                                                            onChange={(
                                                                e,
                                                                i
                                                            ) => {
                                                                onChange(
                                                                    i?.value
                                                                );
                                                                setDropdownPower(
                                                                    i?.value
                                                                );
                                                                return;
                                                            }}
                                                            error={
                                                                errors?.power
                                                                    ?.message
                                                            }
                                                            name={name}
                                                            ref={ref}
                                                            value={
                                                                dropdownPower?.header ||
                                                                ""
                                                            }
                                                            clearable
                                                        />
                                                    )}
                                                />
                                                <ErrorMessage
                                                    content={t(
                                                        errors?.power?.message
                                                    )}
                                                />
                                            </Flex>
                                        </Flex>
                                    )}
                                    {/* bareme kilométrique */}
                                    <Flex
                                        column
                                        gap="gap.smaller"
                                        vAlign="center"
                                    >
                                        <InputLabel
                                            content={
                                                <Text>
                                                    {t(
                                                        "forms.km_fr.bareme.label"
                                                    )}
                                                </Text>
                                            }
                                        />
                                        <BaremeKm>
                                            {isLoading || isFetching ? (
                                                <Loader size="small" />
                                            ) : (
                                                data?.value
                                            )}
                                        </BaremeKm>
                                    </Flex>
                                </Flex>
                                {isOnManagerPage && data?.expense?.comment && (
                                    <CommentSection
                                        user={{
                                            avatar: data?.expense?.user?.avatar,
                                            name: data?.expense?.user?.name,
                                        }}
                                        comment={
                                            data?.expense?.histories?.at(0)
                                                .description
                                        }
                                        date={
                                            data?.expense?.histories?.at(0).date
                                        }
                                    />
                                )}
                                {!isOnManagerPage && (
                                    <Flex column>
                                        <InputLabel
                                            content={t(
                                                "forms.km_fr.comment.label"
                                            )}
                                        />
                                        <TextArea
                                            {...register(
                                                "comment",
                                                VALIDATORS_ADD_EXPENSE_KM_FR.comment
                                            )}
                                            defaultValue={
                                                expense?.expense?.comment
                                            }
                                            styles={{
                                                height: "107px",
                                            }}
                                            clearable
                                            fluid
                                            error={!!errors?.comment?.message}
                                        />
                                        <ErrorMessage
                                            content={t(
                                                errors?.comment?.message
                                            )}
                                        />
                                    </Flex>
                                )}
                            </Flex>
                            <Flex
                                fill
                                vAlign="center"
                                hAlign="center"
                                gap="gap.medium"
                            >
                                <Button
                                    content={t("common.cancel")}
                                    flat
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        return _goback();
                                    }}
                                />
                                <Button
                                    loading={isMutating}
                                    content={t("forms.km_fr.button_update")}
                                    primary
                                    flat
                                />
                            </Flex>
                        </Flex>
                    </WhiteBoard>
                </Wrapper>
            </Container>
        </ContainerFluid>
    );
};

export default ExpensesUpdateFormKmFr;

export const TitlePage = styled(Text)`
    color: #424242;

    /* font-size: 24px; */
    font-size: clamp(18px, 2vw, 24px);
    font-style: normal;
    font-weight: 400;
    line-height: clamp(24px, 2vw, 32px);
`;

export const CardTitle = styled(Text)`
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
`;

const BaremeKm = styled(Text)`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #242424;
`;

const WhiteBoard = styled(Flex)`
    background-color: white;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.11);
    padding: 24px 36px 24px 36px;
`;

const Wrapper = styled(Flex)`
    max-width: 850px;
    width: 100%;
`;

const Title = styled(Text)`
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #242424;
`;
